import { render, staticRenderFns } from "./OnlineQuestion.vue?vue&type=template&id=40c9c0ea&scoped=true"
import script from "./OnlineQuestion.vue?vue&type=script&lang=js"
export * from "./OnlineQuestion.vue?vue&type=script&lang=js"
import style0 from "./OnlineQuestion.vue?vue&type=style&index=0&id=40c9c0ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c9c0ea",
  null
  
)

export default component.exports